import { createClient } from './client';

export const supabase = () => createClient();
